import * as React from "react"
import type { IconProps } from "../types"

const XMarkMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="square"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M7.75 7.75L16.25 16.25M16.25 7.75L7.75 16.25"
        />
      </svg>
    )
  }
)
XMarkMini.displayName = "XMarkMini"

export default XMarkMini
